import { useSyncExternalStore } from "react";
import { localClockPhrase } from "../lib/localClock";
import {
  getMinuteServerSnapshot,
  getMinuteSnapshot,
  subscribeToMinute,
} from "../lib/minuteTick";

/**
 * The client's local time, wherever it is printed. **W20(e) half 3.**
 *
 * ⚠️ **IT RENDERS NOTHING — not an empty element — WHEN THE ZONE IS ABSENT.** Returning `null`
 * rather than an empty `<span>` matters beyond tidiness: an empty span still occupies its
 * parent's `gap`, so a card with no clock would carry a blank row where the clock goes, which
 * is the visual form of the `—` this feature refuses. The line simply does not exist.
 *
 * ⚠️ **AND IT CARRIES A VISUALLY-HIDDEN LABEL.** `9:48 AM in Athens` read aloud with no
 * context is a time and a place with no stated relationship — it could be the coach's. The
 * label says whose clock it is, once, for the reader who cannot see that it sits under the
 * client's name.
 */
export function LocalClockLine({ zone, className, weekday = false }: {
  zone: string | null | undefined;
  className?: string;
  /** The thread head adds THEIR weekday (`2:36 PM in Athens · Thursday`); the Profile card is `2:36 PM in Athens`. ONE
   *  phrase function either way (W72 step 7). */
  weekday?: boolean;
}) {
  const at = useSyncExternalStore(
    subscribeToMinute,
    getMinuteSnapshot,
    getMinuteServerSnapshot,
  );
  const line = localClockPhrase(zone, at, weekday);
  if (line === null) return null;
  return (
    <span className={className}>
      <span className="ht-visually-hidden">Their local time: </span>
      {line}
    </span>
  );
}
